var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('videoPlayer',{ref:"videoPlayer",staticClass:"vjs-custom-skin videoPlayer",attrs:{"options":_vm.playerOptions,"playsinline":true}})}
var staticRenderFns = []

export { render, staticRenderFns }